export function formatPrice(price: number, currency: string) {
  return price.toLocaleString('en-GB', {
    currency,
    style: 'currency'
  });
}
